/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * grimoire/v1/import_export.proto
 * OpenAPI spec version: version not set
 */

/**
 * AutomationKind identifies which builder produced an automation. This also
determines how the automation's logic is represented (see per-value docs).

 - AUTOMATION_KIND_UNSPECIFIED: Unspecified kind. For backward compatibility, consumers MUST treat this as
AUTOMATION_KIND_QUILL for legacy automations that predate this field.
 - AUTOMATION_KIND_QUILL: Built by the original Quill. The automation mapping to spy are defined by
`input_specs` and `code_mapping`.
 - AUTOMATION_KIND_QUILL2: Built by Quill2 (on Rain). The automation mapping to spy is defined in an
opaque "code_manifest.json" artifact; `input_specs` and `code_mapping` are not
populated.
 */
export type V1AutomationKind =
  (typeof V1AutomationKind)[keyof typeof V1AutomationKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1AutomationKind = {
  AUTOMATION_KIND_UNSPECIFIED: 'AUTOMATION_KIND_UNSPECIFIED',
  AUTOMATION_KIND_QUILL: 'AUTOMATION_KIND_QUILL',
  AUTOMATION_KIND_QUILL2: 'AUTOMATION_KIND_QUILL2',
} as const;
